import MediaRoom from "./MediaRoom";

export default MediaRoom;
